import $ from 'jquery'
import { liteClient } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js'
import {
  menu,
  configure,
  clearRefinements,
  refinementList,
  pagination,
} from 'instantsearch.js/es/widgets'
import { history } from 'instantsearch.js/es/lib/routers'
import {
  connectSearchBox,
  connectCurrentRefinements,
} from 'instantsearch.js/es/connectors'
import { connectHits } from 'instantsearch.js/es/connectors'
import { algoliaAppId, algoliaApiKey, trainingSearchIndex } from '../variables'
import { trainingHit, noResult } from '../templates'
import { headerSearch, createArchiveUrl } from '../header-search'

// eslint-disable-next-line no-undef
const { __, _n, sprintf } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

let trainingsSearch
const checkEl = document.querySelector('.pt-trainings-inline-search-handler')
if (checkEl) {
  const searchClient = liteClient(algoliaAppId, algoliaApiKey)

  trainingsSearch = instantsearch({
    indexName: trainingSearchIndex,
    searchClient,
    insights: true,
    clickAnalytics: true,
    routing: {
      router: history({
        push(url) {
          window.history.pushState({}, '', url)
          createArchiveUrl(this.getLocation().search)
        },
      }),
    },
  })

  const trainingItem = ({ hits, sendEvent, widgetParams }) => {
    const container = document.querySelector(widgetParams.container)

    container.innerHTML = `
      ${
        hits.length
          ? hits
              .map((item) => {
                return trainingHit(item, 'g-col-12 g-col-sm-6 g-col-xxl-4')
              })
              .join('')
          : noResult
      }
  `

    container.querySelectorAll('.feed-training-hit__wrapper')
      .forEach((element, index) => {
        element.addEventListener('click', (event) => {
          sendEvent('click', hits[index], 'Training Clicked')
        })
      })
  }

  const trainingItems = connectHits(trainingItem)

  const renderSearchBox = (renderOptions, isFirstRender) => {
    const { query, refine, clear, isSearchStalled, widgetParams } =
      renderOptions
    const container = document.querySelector(widgetParams.container)

    if (isFirstRender) {
      const input = document.createElement('input')
      input.type = 'search'
      input.placeholder = widgetParams.placeholder

      container.insertAdjacentHTML('beforeend', object.loader)

      const reset = document.createElement('button')
      reset.type = 'reset'
      reset.insertAdjacentHTML('beforeend', '<i class="vn-icons-close"></i>')

      const submit = document.createElement('button')
      submit.type = 'submit'
      submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>')

      input.addEventListener('input', (training) => {
        refine(training.target.value)

        if (headerSearch !== undefined) {
          headerSearch.setUiState({
            [trainingSearchIndex]: {
              query: event.target.value,
            },
          })
        }
      })

      reset.addEventListener('click', () => {
        clear()

        if (headerSearch !== undefined) {
          headerSearch.setUiState({
            [trainingSearchIndex]: {
              query: '',
            },
          })
        }
      })

      container.appendChild(input)
      container.appendChild(reset)
      container.appendChild(submit)
    }

    container.querySelector('input').value = query
    container.querySelector('.vn-loader').hidden = !isSearchStalled
    container.querySelector('button[type="reset"]').hidden =
      isSearchStalled || !query
    container.querySelector('button[type="submit"]').hidden = isSearchStalled
  }

  const customSearchBox = connectSearchBox(renderSearchBox)

  const renderCurrentRefinements = ({ items, widgetParams }) => {
    const container = document.querySelector(widgetParams.container)
    const totalItemCount = items.reduce(
      (acc, curr) => acc + curr.refinements.length,
      0
    )

    container.innerHTML = sprintf(
      _n('%s active filter', '%s active filters', totalItemCount, 'vn'),
      totalItemCount
    )
  }

  const customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  )

  trainingsSearch.addWidgets([
    customSearchBox({
      container: '.pt-trainings-inline-search-handler',
      placeholder: __('Diploma, profession, training...', 'vn'),
      showLoadingIndicator: false,
    }),

    customCurrentRefinements({
      container: '.pt-trainings-active-filters-handler',
    }),

    clearRefinements({
      container: '.pt-trainings-reset-handler',
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`<span
            >${hasRefinements
              ? __('Remove filters', 'vn')
              : __('No filters', 'vn')}</span
          >`
        },
      },
    }),

    menu({
      container: '.pt-trainings-post-type-handler',
      attribute: 'post_type.name',
      sortBy: ['name'],
    }),

    menu({
      container: '.pt-trainings-diplomas-handler',
      attribute: 'diplomas.name',
    }),

    menu({
      container: '.pt-trainings-training-locations-handler',
      attribute: 'training_locations.name',
    }),

    refinementList({
      container: '.pt-trainings-training-levels-handler',
      attribute: 'training_levels.name',
    }),

    refinementList({
      container: '.pt-trainings-certification-type-handler',
      attribute: 'training_certifications_type.name',
    }),

    refinementList({
      container: '.pt-trainings-training-branches-handler',
      attribute: 'training_branches.name',
    }),

    refinementList({
      container: '.pt-trainings-job-sheets-handler',
      attribute: 'job_sheets.name',
      sortBy: ['name'],
    }),

    trainingItems({
      container: '.pt-trainings-hits',
    }),

    pagination({
      container: '.pt-trainings-pagination-handler',
      showFirst: false,
      showLast: false,
      scrollTo: document.querySelector('.pt-training-posts-handler'),
      templates: {
        previous: '<i class="vn-icons-angle-left"></i>',
        next: '<i class="vn-icons-angle-right"></i>',
      },
    }),

    configure({
      hitsPerPage: 18,
    }),
  ])

  trainingsSearch.start()

  trainingsSearch.addWidget({
    render: function () {
      const search = document.querySelector('.header-search-handler')
      if (search) search.style.visibility = 'visible'
    },
  })
}

$('.pt-trainings-filter-toggle').on('click', function () {
  $('body').toggleClass('trainings-filter-active')
})

export { trainingsSearch }
